
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M24.0186 10.6648C24.2981 10.9442 24.4995 11.2919 24.6028 11.6733C25.1973 14.0652 25.0599 17.8429 24.6143 20.3271C24.5111 20.7085 24.3097 21.0562 24.0301 21.3355C23.7506 21.6149 23.4028 21.8162 23.0212 21.9194C21.6244 22.3002 16.0024 22.3002 16.0024 22.3002C16.0024 22.3002 10.3805 22.3002 8.98365 21.9194C8.60209 21.8162 8.25423 21.6149 7.97473 21.3355C7.69522 21.0562 7.49381 20.7085 7.39057 20.3271C6.79258 17.9456 6.95651 14.1656 7.37902 11.6848C7.48227 11.3034 7.68368 10.9558 7.96318 10.6764C8.24269 10.397 8.59054 10.1957 8.9721 10.0925C10.3689 9.71173 15.9909 9.7002 15.9909 9.7002C15.9909 9.7002 21.6129 9.7002 23.0097 10.081C23.3912 10.1842 23.7391 10.3855 24.0186 10.6648ZM18.9168 16.0008L14.3143 18.6811V13.3204L18.9168 16.0008Z","fill":"currentColor"}})])
          )
        }
      }
    